module.exports = __webpack_public_path__ + "2bb779f00d33432a108432ba1bca483f.pdf";